import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  // 關閉瀏覽器自動還原捲動位置（reload/back/forward）
  useLayoutEffect(() => {
    try {
      if (typeof window !== "undefined" && window.history && "scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
    } catch (e) { void e; }
    return () => {
      try {
        if (typeof window !== "undefined" && window.history && "scrollRestoration" in window.history) {
          window.history.scrollRestoration = "auto";
        }
      } catch (e) { void e; }
    };
  }, []);

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    // 再補一次，避免延遲載入把畫面推下去
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, 0);
    return () => clearTimeout(t);
  }, [pathname, search, hash]);

  return null;
};

export default ScrollToTop;
